import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-tab-forum',
  templateUrl: './tab-forum.page.html',
  styleUrls: ['./tab-forum.page.scss'],
})
export class TabForumPage implements OnInit {
  isMovil:boolean = false;
  constructor(private router: Router, public services:ServiceService) { }

  ngOnInit() {
    this.isMovil = this.services.isMovil();
    this.router.navigate(['/tab-forum/comunity']);
  }

}
